import Vue from 'vue'
import Vuex from 'vuex'
import AuthenticationStore from './authentication/index.js'
import CalendarStore from './calendar'
import ServiceStore from './service/index.js'
import UserStore from './user/index.js'
import BusinessStore from './business/index.js'
import BusinessServiceStore from './businessService/index.js'
import ServiceStateStore from './serviceState/index'
import ServiceNotificationStore from './serviceNotification'
import MonthlyStates from './monthlyStates'
import ServiceFolderStore from './serviceFolder'
import TaskStore from './task/index.js'
import BusinessFolderStore from './businessFolder'
import BusinessTaskStore from './businessTask/index.js'
import NotesStore from './notes'
import PasswordStore from './password'
import UtilsStore from './utils'
import BusinessGroupStore from './businessGroup'
import EmailStore from './email'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    EmailStore,
    BusinessGroupStore,
    NotesStore,
    CalendarStore,
    ServiceFolderStore,
    ServiceNotificationStore,
    MonthlyStates,
    AuthenticationStore,
    ServiceStore,
    UserStore,
    BusinessStore,
    BusinessServiceStore,
    ServiceStateStore,
    TaskStore,
    BusinessFolderStore,
    BusinessTaskStore,
    PasswordStore,
    UtilsStore
  },
});
